module.exports = __webpack_public_path__ + "static/media/save.fbae1173.svg";